/*eslint no-undef: "error"*/
<template>
  <div>
      <gmap-map :center="center" ref="myMap" :options="{streetViewControl: false}" :zoom="14" style="height: 100vh">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'mapa',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'https://mensajeros.guepardos.co/api/v2',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajero: {},
      puntos: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let vm = this
      vm.$http.get(`${vm.URL}/userData/${vm.$route.params.id}`)
      .then(data => {
        vm.usuario = data.body
        if (vm.usuario.geo) {
          vm.dibujarPuntos()
          vm.dibujarCirculos()
        } else {
          console.log('no tiene puntos de localizacion')
        }
      })
    },
    dibujarPuntos () {
      let vm = this
      vm.markers = []
      vm.center = new google.maps.LatLng(parseFloat(vm.usuario.geo.lat), parseFloat(vm.usuario.geo.lng))
      vm.markers.push({
        position: {
          lat: parseFloat(vm.usuario.geo.lat),
          lng: parseFloat(vm.usuario.geo.lng)
        },
        infoText: `<i class="fa fa-user-circle-o" aria-hidden="true"></i> ${vm.usuario.nombre} <br> <i class="fa fa-home" aria-hidden="true"></i> ${vm.usuario.direccion}`,
        icon: require('../assets/car.png')
      })
    },
    dibujarCirculos () {
      let vm = this
      vm.$refs.myMap.resizePreserveCenter()
      let center = {lat: vm.usuario.geo.lat, lng: vm.usuario.geo.lng}
      vm.$http.get('https://mensajeros.guepardos.co/api/v2/franchises')
      .then(response => {
        let cityCircle1 = new google.maps.Circle({
          strokeColor: '#02C3BD',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#02C3BD',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio1) * 1000
        })
        let cityCircle2 = new google.maps.Circle({
          strokeColor: '#00B9AE',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#00B9AE',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio2) * 1000
        })
        let cityCircle3 = new google.maps.Circle({
          strokeColor: '#009F93',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#009F93',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio3) * 1000
        })
        let cityCircle4 = new google.maps.Circle({
          strokeColor: '#037171',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#037171',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio4) * 1000
        })
        let cityCircle5 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio5) * 1000
        })
        let cityCircle6 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio6) * 1000
        })
        let cityCircle7 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio7) * 1000
        })
        let cityCircle8 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: (response.body[0].radio8) * 1000
        })
      })
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  },
  notifications: {
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
</style>



// WEBPACK FOOTER //
// UserMap.vue?f94c0bd0